import {
  FIELD_ORDER_UI_SCHEMA_KEY,
  SECTION_NAME_UI_SCHEMA_KEY,
  ShapeUISchemaNestedShapeValues,
  SHOW_DIVIDER_LINE_KEY,
} from '../../StepConfigEditorTypes';
import {
  createAxisConfigGroup,
  createDiscreteColorPaletteSection,
  createErrorBarsSection,
  createLegendStyleSection,
  createMarkerStyleSection,
  createReferenceLineSection,
  createXAxisRangeStyleSection,
  createYAxisRangeStyleSection,
} from './ChartSchemaHelpers';

/**
 * Line Chart configuration sections for the Configure tab
 */
export const LINE_CHART_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: [
    'axesSection',
    'errorBarsSection',
    'seriesAndColorPaletteSection',
    'referenceLinesSection',
  ],
  axesSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['xAxisGroup', 'yAxisGroup'],
    xAxisGroup: createAxisConfigGroup('x', {includePointLabel: true}),
    yAxisGroup: createAxisConfigGroup('y'),
  },
  seriesAndColorPaletteSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['seriesSection', 'colorSection'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Series & Color Palette',
    seriesSection: {
      [FIELD_ORDER_UI_SCHEMA_KEY]: ['seriesColumnName'],
      seriesColumnName: {
        displayName: 'Series',
        configShapePath: ['chartConfig', 'parameters', 'seriesColumnName'],
        fieldSettings: {
          allowSelectNull: true,
          noColumnSelectedText: 'None',
        },
      },
    },
    colorSection: createDiscreteColorPaletteSection(['chartConfig', 'parameters', 'seriesColumnName']),
  },
  errorBarsSection: createErrorBarsSection(),
  referenceLinesSection: createReferenceLineSection(),
} as const satisfies ShapeUISchemaNestedShapeValues;

/**
 * Line Chart style sections for the Style tab
 */
export const LINE_CHART_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['legendSection', 'markerStyleSection', 'xAxisSection', 'yAxisSection'],
  legendSection: createLegendStyleSection(),
  markerStyleSection: createMarkerStyleSection({allowNullShape: true}),
  xAxisSection: createXAxisRangeStyleSection(),
  yAxisSection: createYAxisRangeStyleSection({includesZero: true}),
} as const satisfies ShapeUISchemaNestedShapeValues;
